/* ADD Knowledge categories */
export const ADD_COURSE = "ADD_COURSE"
export const ADD_COURSE_SUCCESS = "ADD_COURSE_SUCCESS"
export const ADD_COURSE_CLEAN = "ADD_COURSE_CLEAN"
export const API_ERROR = "API_ERROR"
